<template>
  <div class="custom-number-input-container">
    <span>{{ label }}: </span>
    <div class="custom-number-input-control">
      <Field
        v-slot="{ field }"
        v-model="mutatedValue"
        :label="label"
        :name="name"
        :rules="validation"
      >
        <button
          type="button"
          @click.self="removeQuantity"
        >
          -
        </button>
        <input
          :ref="name"
          type="number"
          :min="min"
          :max="max"
          class="custom-number-input"
          v-bind="field"
          @input="onInput"
        >
        <button
          type="button"
          @click.self="addQuantity"
        >
          +
        </button>
        <ErrorMessage
          class="error-msg"
          :name="name"
        />
      </Field>
    </div>
  </div>
</template>

<script>
import { Field, ErrorMessage } from 'vee-validate'
/**
 * Props:
 * value: on load value (Number),
 * name: input's name (String),
 * min: minimum of the input (Number),
 * max: maximum of the input (Number)
 */
export default {
  name: 'CustomNumberInput',
  components: { Field, ErrorMessage },
  props: {
    label: String,
    validation: [String, Boolean],
    defaultValue: [Number, String],
    name: String,
    min: [Number, String],
    max: [Number, String],
    formGenerator: String
  },
  emits: ['addData'],
  data() {
    return {
      mutatedValue: this.defaultValue ? this.defaultValue : 0
    }
  },
  mounted() {
    this.mutatedValue
      ? this.$emit('addData', { value: this.mutatedValue, name: this.name })
      : this.$emit('addData', { value: '', name: this.name })
  },
  methods: {
    /**
     * removing quantity with button
     */
    removeQuantity() {
      if (this.mutatedValue > this.min) this.mutatedValue--
      if (!this.min && this.mutatedValue > 0) this.mutatedValue--
      this.$emit('addData', { value: this.mutatedValue, name: this.name })
    },
    /**
     * removing quantity with button
     */
    addQuantity() {
      if (this.mutatedValue < this.max) this.mutatedValue++
      if (!this.max) this.mutatedValue++
      this.$emit('addData', { value: this.mutatedValue, name: this.name })
    },
    onInput({ target }) {
      this.$emit('addData', { value: target.value, name: this.name })
    }
  }
}
</script>

<style lang="scss" scoped>
  .custom-number-input-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;

    /* Tablet (portrait) */
    @media only screen and (width >= 768px) {
      margin: 20px 0;
    }

    /* Desktops and laptops */
    @media only screen and (width >= 1024px) {
      margin: 20px 0;
    }

    /* Large screens */
    @media only screen and (width >= 1824px) {
      margin: 20px 0;
    }

    .custom-number-input-control {
      margin-left: 20px;
      min-width: 90px;
    }

    span {
      height: fit-content;
      text-align: left;
    }

    button {
      color: white;
      background-color: rgb(var(--custom-color-main));
      width: 25px;
      height: 25px;
      border: 1px solid rgb(var(--custom-color-main));
    }

    .custom-number-input {
      width: 30px;
      text-align: center;
    }
  }
</style>
